module.exports = __webpack_public_path__ + "img/clock2.3622f5c0.svg";